import React from "react";
import styled, { withTheme } from "styled-components";
import { connect } from "react-redux";
import { t } from "../../core/translate";
import { styledMedia } from "../../components/mediaquery/breakpoints";
import { OffScreenStyles } from "../../components/mixins";
import { selectors as brandSelectors } from "../../../redux/brand";
import { actions as modalActions } from "../../../redux/modals";
import { actions as storageActions } from "../../../redux/storage";
import { colors } from "chameleonjs";

const LeadingCard = styled.button`
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  border: 0;
  background: transparent;
  color: ${props =>
    props.brandColor
      ? colors[props.brandColor].getShade(7)
      : props.theme.color.base.getShade(8)};
  display: flex;
  flex-direction: column;
  align-items: stretch;

  #onboarding-card-top-half {
    background-color: ${props =>
      props.brandColor
        ? colors[props.brandColor].getShade(5)
        : props.theme.color.base.getShade(8)};
    border-radius: 4px 4px 0 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    flex-grow: 1;

    #onboarding-card-icon-container {
      border: 8px solid #ffffff;
      box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
      background-color: ${props =>
        props.brandColor
          ? colors[props.brandColor].getShade(6)
          : props.theme.color.base.getShade(9)};
      height: 100px;
      width: 100px;
      transform: translateY(50%);
      margin-top: auto;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        height: 45px;
      }
    }
  }

  #onboarding-card-bottom-half {
    font-weight: 500;
    font-size: 1.6rem;
    padding-top: 70px;
    margin: 0 auto;
    flex-grow: 1;
    ${styledMedia.small`
      padding-top: 55px;
    `};

    #onboarding-bottom-primary-text {
      width: 100%;
      ${styledMedia.medium`
        font-size: 1.4rem;
      `};
    }

    #onboarding-bottom-secondary-text {
      width: 100%;
      font-size: 1.6rem;
      ${styledMedia.medium`
        ${OffScreenStyles}
      `};
    }

    #onboarding-bottom-action {
      border-radius: 4px;
      font-size: 14px;
      font-weight: 500;
      height: 32px;
      line-height: 17px;
      margin: 0 auto;
      padding-top: 20px;
      text-align: center;
      width: 107px;
    }
  }
`;

const OnboardingBook = ({ customizations, chegg, openWelcomeModal }) => (
  <LeadingCard
    brandColor={customizations.color}
    chegg={chegg}
    onClick={openWelcomeModal}
  >
    <div id="onboarding-card-top-half">
      <div id="onboarding-card-icon-container">
        <img alt="" aria-hidden={true} src={customizations.icon} />
      </div>
    </div>
    <div id="onboarding-card-bottom-half">
      <div id="onboarding-bottom-primary-text">
        {customizations.primaryText ||
          t("library.explore-your-library", "Explore your new library!")}
      </div>
      <div id="onboarding-bottom-secondary-text">
        {customizations.secondaryText}
      </div>
      <div id="onboarding-bottom-action">
        {customizations.actionText || t("library.take-tour", "Take a Tour")}
      </div>
    </div>
  </LeadingCard>
);

const mapStateToProps = state => ({
  chegg: brandSelectors.getBrandValue(state, "Chegg.isCheggBrand", false),
  customizations: brandSelectors.getBrandValue(
    state,
    "CustomSwimlaneCard",
    false
  )
});

const mapDispatchToProps = dispatch => ({
  openWelcomeModal: () => {
    dispatch(modalActions.openModal("WelcomeOnboarding"));
    dispatch(storageActions.setHasSeenWelcomeOnboarding());
  }
});

export default withTheme(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(OnboardingBook)
);
